var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('table',{staticClass:"resumo-v-table font-avenir m-t-lg resumo-fin extrato_"},[_c('tbody',[_c('tr',[_c('td',[_c('span',[_vm._v("Emissão da nota")])]),_c('td',{staticClass:"text-right"},[_c('span',[_vm._v("XXX")])])])])])])
}]

export { render, staticRenderFns }